import { callFirebaseFunction } from "../callFirebaseFunction"
import Config from "../../config"
import { auth } from "../firebase"
import { load, save } from "../../utils/storage"
import { getFunctionUrl } from "../callFirebaseHttpFunction.ts"
import { UserDeviceTokenDisconnectedInput } from "../../../../firebase/functions/src/libs/cruisen-contract"

const userDeviceTokenKey = () => `user:${auth.currentUser?.uid}:deviceToken`

export const saveUserDeviceToken = async ({
  token,
  trackOnline,
  disconnected,
}: {
  token?: string
  trackOnline?: boolean
  disconnected?: boolean
} = {}) => {
  if (!token && auth.currentUser) {
    token = load<string>(userDeviceTokenKey())
  }

  if (!token) return

  if ("sendBeacon" in navigator && disconnected) {
    navigator.sendBeacon(
      getFunctionUrl("userDeviceTokenDisconnected"),
      JSON.stringify({
        userId: auth.currentUser.uid,
        token,
        platform: "web",
        bundleId: "com.cruisen.web",
        appVersion: Config.appVersion,
      } as UserDeviceTokenDisconnectedInput),
    )
    return
  }

  await callFirebaseFunction({
    name: "saveUserDeviceToken",
    payload: {
      token,
      platform: "web",
      bundleId: "com.cruisen.web",
      appVersion: Config.appVersion,
      trackOnline,
      disconnected,
    },
  })

  // delete old device token when it has changed
  const existingToken = load<string>(userDeviceTokenKey())
  if (existingToken && existingToken !== token) {
    await deleteUserDeviceToken(existingToken)
  }

  if (auth.currentUser) save(userDeviceTokenKey(), token)
}

export const deleteUserDeviceToken = async (token?: string): Promise<void> => {
  if (!token && auth.currentUser) {
    token = load<string>(userDeviceTokenKey())
  }
  if (!token) return

  await callFirebaseFunction({
    name: "deleteUserDeviceToken",
    payload: { token },
  })
}
